import React, { useEffect, useState } from "react";
import { Button, Modal, Form, Spin } from "antd";
import CategoriesTable from "../Tables/Categories";
import CategoryForm from "../Forms/Category";
import { useDispatch, useSelector } from "react-redux";
import {
	createCategory,
	fetchCategories,
	updateCategory,
} from "../../actions/category";

import "./Categories.scss";
import { PAGE_SIZE } from "../../constants";
import { Link } from "react-router-dom";

const CategoriesPage = () => {
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [image, setImage] = useState(null);
	const [categoryId, setCategoryId] = useState(null);
	const { categories, loading } = useSelector((state) => state.fetchCategories);
	const { categoryUpdated } = useSelector((state) => state.updateCategory);
	const [pagination, setPagination] = useState({});
	const [currentPage, setCurrentPage] = useState(1);
	const limit = Number(PAGE_SIZE) || 20;

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const handleEdit = (record) => {
		showModal();
		setCategoryId(record.id);
		form.setFieldsValue(record);
	};

	const convertUploadFile = (file) => {
		const fr = new FileReader();

		fr.onload = function (e) {
			const result = JSON.parse(e.target.result);
			const formatted = JSON.stringify(result, null, 2);
			setImage(formatted);
		};

		fr.readAsText(file);
	};

	const handleSubmitForm = (values) => {
		if (categoryId) {
			dispatch(updateCategory(categoryId, values));
		} else {
			const newValues = { ...values };
			newValues.image = JSON.parse(image);
			dispatch(createCategory(newValues));
		}
		handleOk();
	};

	const withAction = (record) => {
		return (
			<span className="action" style={{ display: "flex" }}>
				<Link to={`/survey-categories/${record.id}`}>
					<Button type="link" className="btn-table-action-primary">
						View
					</Button>
				</Link>
				<Button
					type="link"
					className="btn-table-action-primary"
					onClick={() => handleEdit(record)}
				>
					Edit
				</Button>
			</span>
		);
	};

	const handleFilter = (params) => {
		setCurrentPage(params.page);
		const startAt = (params.page - 1) * Number(PAGE_SIZE);
		dispatch(fetchCategories({ start: Number(startAt), count: PAGE_SIZE }));
	};

	const handleTableChange = (params) => {
		handleFilter(params);
	};

	useEffect(() => {
		dispatch(fetchCategories({ start: 0, count: PAGE_SIZE }));
	}, []);

	useEffect(() => {
		if (categoryUpdated)
			dispatch(fetchCategories({ start: 0, count: PAGE_SIZE }));
	}, [categoryUpdated]);

	useEffect(() => {
		if (categories) {
			setPagination({
				showSizeChanger: false,
				current: currentPage,
				pageSize: limit,
				total: categories.data.total,
				showTotal: (total) => `${total} Items`,
			});
		}
	}, [categories]);

	return (
		<Spin spinning={loading} tip="Loading ...">
			<div className="categories-container">
				<div className="page-header">
					<div className="page-header-breadbrumb">
						<ul>
							<li>Survey Categories</li>
						</ul>
					</div>
				</div>
				<div className="page-content">
					{categories && (
						<CategoriesTable
							rowKey="id"
							dataSource={categories.data.data}
							pagination={pagination}
							onChange2={handleTableChange}
							scrollHeight="calc(100vh - 275px)"
							actionWidth={150}
							withAction={withAction}
						/>
					)}
				</div>
				<Modal
					className="add-category-modal"
					visible={isModalVisible}
					onOk={handleOk}
					onCancel={handleCancel}
					footer={null}
				>
					{categories && (
						<CategoryForm
							form={form}
							categories={categories.data.data}
							categoryId={categoryId}
							handleOk={handleOk}
							handleSubmitForm={handleSubmitForm}
							convertUploadFile={convertUploadFile}
							handleCancel={handleCancel}
						/>
					)}
				</Modal>
			</div>
		</Spin>
	);
};

export default CategoriesPage;
